import { Controller, useFormContext } from 'react-hook-form';

import { ColorSquare } from '@ui/components/ColorSquare';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

export function ThemeColorInput() {
  const { control } = useFormContext<{ themeColor: string | null }>();
  return (
    <FormRow>
      <FormLabel
        hint={
          <span>
            Начинается с &quot;#&#34; и содержит 6 символов.{' '}
            <a href="https://colorpicker.me/">https://colorpicker.me/</a>
          </span>
        }
      >
        Цвет страниц
      </FormLabel>
      <FormInput>
        <Controller
          name="themeColor"
          control={control}
          rules={{
            validate: (value) => !value || (value.startsWith('#') && value.length === 7),
          }}
          render={({ field: { value, onChange, disabled } }) => (
            <Input
              leftLabel={<ColorSquare color={value ?? ''} />}
              value={value as string}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
